module.exports = __webpack_public_path__ + "assets/img/81@3x.195ac9d7.png";